import React from 'react';
import ResumeBody from './ResumeBody';

function Resume() {
  return <ResumeBody />;
}

export default Resume;
